import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ApolloClient, InMemoryCache, ApolloProvider } from "@apollo/client";

import { UserProvider } from "./contexts/UserContext";
import { CalculationsContextProvider } from "./contexts/CalculationsContext";
const endpoint = process.env.REACT_APP_GRAPHQL_ENDPOINT || "";
const client = new ApolloClient({
  uri: endpoint,
  headers: {
    "x-hasura-admin-secret": process.env.REACT_APP_API_SECRET || "",
    // or "x-hasura-access-key": "YOUR_ACCESS_KEY_VALUE"
  },
  cache: new InMemoryCache(),
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // TODO: UNCOMMENT STRICT MODE FOR DEV TESTING
  // <React.StrictMode>
  //   {/* @ts-ignore */}
  <CalculationsContextProvider>
    <UserProvider>
      <ApolloProvider client={client}>
        {/* @ts-ignore */}
        <App />
      </ApolloProvider>
    </UserProvider>
  </CalculationsContextProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
